import { CompanyData as CompanyDataType } from './../types/constants';

import { kinza } from './experience/kinza';
import { epigro } from './experience/epigro';
import { cyrup } from './experience/cyrup';
import { coreIllumination } from './experience/core-illumination';
import { bazzle } from './experience/bazzle';
import { propertyShell } from './experience/propertyshell';

export const CompanyData: CompanyDataType[] = [
  propertyShell,
  bazzle,
  coreIllumination,
  cyrup,
  epigro,
  kinza,
];
